import { useCallback, useEffect, useRef } from "react";
import { useCheckoutSend } from "@checkout/context";
import {
  CartFulfillEventType,
  cartFulfillSelectors,
  type CartFulfillEvents,
} from "@checkout/states";
import { useCheckoutStateSelector as useSelector } from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  ActionLink,
  IconComponent,
  IconName,
  MobilePopoverCard,
} from "@hopper-b2b/ui";
import config from "../../../../../utils/config";
import styles from "./styles.module.scss";

export const UserActionComponent = () => {
  const { t } = useI18nContext();

  const send = useCheckoutSend<CartFulfillEvents>();
  const closeHandler = useCallback(() => {
    send(CartFulfillEventType.USER_ACTION_ERROR);
  }, [send]);

  const iframeSrc = useSelector(cartFulfillSelectors.getCartFulfillUserActions);
  const iframeRef = useRef(null);

  // Not used but helpful for local development
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const sendSuccess = useCallback(() => {
    send(CartFulfillEventType.USER_ACTION_SUCCESS);
  }, [send]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== new URL(iframeSrc.url).origin) {
        console.warn("Message received from an untrusted origin");
      }
      if (event.data === "action-complete") {
        send(CartFulfillEventType.USER_ACTION_SUCCESS);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [iframeSrc.url, send]);

  useEffect(() => {
    const message = {
      type: "CONFIRM_RYANAIR",
      payload: {
        ryanairUrl: iframeSrc.url,
      },
    };

    window.parent.postMessage(message, config.UBER_URL);
  }, [iframeSrc.url]);

  return (
    <MobilePopoverCard
      centered
      fullScreen
      open
      className={styles.UserActionComponent}
      contentClassName={styles.UserActionComponentContent}
      paperClassName={styles.UserActionComponentPaper}
      onClose={closeHandler}
      topRightButton={
        <ActionLink
          className="review-price-breakdown-modal-close-button"
          content={
            <IconComponent
              ariaLabel={t("close")}
              className={"close-icon"}
              name={IconName.Close}
            />
          }
          label={t("close")}
          onClick={closeHandler}
        />
      }
    >
      <iframe
        ref={iframeRef}
        src={iframeSrc.url}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        title="Action Iframe"
      />
    </MobilePopoverCard>
  );
};
